import Button, { ButtonProps } from "@mui/material/Button";
import styled from "@mui/material/styles/styled";

import { lightOrDark } from "@app/embedded/theme/utils";

export interface SeeMoreButtonProps extends ButtonProps {
  hide?: boolean;
  viewLessLabel?: string;
  viewMoreLabel?: string;
  viewingMore?: boolean;
}

const StyledButton = styled(Button)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  lineHeight: "inherit",
  verticalAlign: "baseline",
  minWidth: 0,
  width: "fit-content",
  fontSize: "0.875rem",
  padding: 0,
  color: lightOrDark(
    theme.palette.shades.primary[500],
    theme.palette.shades.primary[200]
  )(theme),
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

const SeeMoreButton = ({
  hide = false,
  viewingMore = false,
  viewLessLabel = "see less",
  viewMoreLabel = "see more",
  ...buttonProps
}: SeeMoreButtonProps) => {
  if (hide) return null;

  return (
    <StyledButton disableRipple {...buttonProps}>
      {viewingMore ? viewLessLabel : viewMoreLabel}
    </StyledButton>
  );
};

export default SeeMoreButton;
